import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next) // kết nối với React
  .init({
    resources: {
      en: {
        translation: {
          welcome: "Welcome",
          loading: "Loading...",
          storyList: "Story List",
          yourBadges: "Your Badges",
          readingStreak: "Reading Streak",
          streakOf: "Streak of",
          days: "days",
          // Thêm các key-value cho tiếng Anh
        }
      },
      fr: {
        translation: {
          welcome: "Bienvenue",
          loading: "Chargement...",
          storyList: "Liste des histoires",
          yourBadges: "Vos badges",
          readingStreak: "Série de lecture",
          streakOf: "Série de",
          days: "jours",
          // Thêm các key-value cho tiếng Pháp
        }
      },
      vi: {
        translation: {
          welcome: "Chào mừng",
          loading: "Đang tải...",
          storyList: "Danh sách truyện",
          yourBadges: "Các huy hiệu của bạn",
          readingStreak: "Chuỗi đọc",
          streakOf: "Chuỗi",
          days: "ngày",
          // Thêm các key-value cho tiếng Việt
        }
      }
    },
    lng: "vi", // Ngôn ngữ mặc định
    fallbackLng: "vi", // Ngôn ngữ dự phòng
    interpolation: {
      escapeValue: false // không cần thoát ký tự
    }
  });

export default i18n; 